import React, { useState, useEffect } from "react";
import RoundedLinkButton from "../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import "./latestNews.css";
import useCheckIfMobile from "../../../customHooks/useCheckIfMobile";
import imgPlaceholder from "../../../assets/logo/green-v.png";
import { Link } from "react-router-dom";
import Spinner from "../../../components/Spinner/Spinner";
import { client } from "../../../utils/sanity";
import { urlFor } from "../../../utils/sanityImgBuilder";
import { formatDate } from "../../../utils/formatDate";
import { ReadMoreButton } from "../../../components/Buttons/ReadMoreButton/ReadMoreButton";

export const LatestNews = () => {
  const isMobile = useCheckIfMobile();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    client
      .fetch(
        `
      *[_type == "post"] | order(publishedAt desc)[0] {
        _id,
        title,
        "slug": slug.current,
        publishedAt,
        mainImage
      }
    `,
      )
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <div className="blog-index-spinner-wrapper">
        <Spinner />
      </div>
    );

  if (error) return <p>Ett fel uppstod, vänligen försök igen senare.</p>;

  return (
    <>
      <div className="latest-news">
        <div className="latest-news-text-container">
          <h2 className="latest-news-title">Senaste nytt om Vakansa</h2>
          <p>
            Följ vår utveckling och läs det senaste om oss i vår nya blogg! Här
            kan du hitta information om branschen i stort, om hur det ser ut på
            lokalmarknaden och hur hållbarhetsfrågorna tangerar det vi gör.
          </p>
          {isMobile && isClicked === false ? (
            <ReadMoreButton onToggle={handleClick} isExpanded={isClicked} />
          ) : (
            <>
              <br />
              <p>
                Det brukar sägas att bygg- och fastighetsbranschen är samhällets
                motor och då är det viktigt att hålla koll på vad som sker i
                branschen. Annars är risken att vi inte bygger en stad för
                människor och verksamheter, utan människor och verksamheter som
                anpassar sig för staden.
              </p>
              {isMobile && isClicked === true ? (
                <ReadMoreButton onToggle={handleClick} isExpanded={isClicked} />
              ) : null}
            </>
          )}
          <div className="button-container">
            <RoundedLinkButton
              label={"Gå till bloggen"}
              href={"/blogg"}
              color="green"
              size="lg"
            />
          </div>
        </div>
        {!isMobile && post && (
          <Link
            to={`/blogg/${post.slug}`}
            className="latest-news-blog-card-link"
            aria-label="Länk till bloggen"
          >
            <div className="latest-news-blog-card">
              <img
                src={
                  post.mainImage ? urlFor(post.mainImage).url() : imgPlaceholder
                }
                alt={post.title}
                width={416}
                height={260}
              />
              <h3 className="latest-news-blog-card-title">{post.title}</h3>
              <p>{formatDate(post.publishedAt)}</p>
            </div>
          </Link>
        )}
      </div>
    </>
  );
};
